/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, ListGroup, Row, Col, Badge } from 'react-bootstrap';
import * as S from './styles';

export interface IOptionsProps {
  percent?: string;
  title?: string[];
  value?: string;
}

export interface IOptionsWidgetProps {
  title: string;
  description?: string;
  headers?: string[];
  listItems?: IOptionsProps[];
}

const getFirstLetterOfEachWord = (text) => text?.match(/\b\w/g).join('');

export const ListItemsComp = ({
  title,
  description,
  headers,
  listItems,
}: IOptionsWidgetProps) => {
  const _renderSubTitleIf = () => {
    if (description) {
      return <p> {description} </p>;
    }
  };

  const _renderTitle = () => {
    if (title) {
      return (
        <Card.Header className="border-bottom">
          <h2 className="fs-5 fw-bold mb-0">{title}</h2>
          {_renderSubTitleIf()}
        </Card.Header>
      );
    }
  };

  const _renderPercent = (payout: any) => {
    if (payout?.percent) {
      return (
        <Col xs="auto">
          <Badge bg="secondary" className="m-0 p-2">
            {payout?.percent}
          </Badge>
        </Col>
      );
    }
    return null;
  };
  const _renderTitleIf = (payout: any) => {
    if (
      payout?.title &&
      !Array.isArray(payout?.title) &&
      typeof (payout?.title === 'string')
    ) {
      return (
        <Col xs="auto" className="px-2">
          <p className="fs-6 text-dark mb-0 w-100">{payout?.title}</p>
        </Col>
      );
    }
    if (Array.isArray(payout?.title)) {
      return (
        <Col xs="auto" className="px-2">
          {payout?.title?.map((str: string, index: number) => {
            return (
              <>
                <h4 className="fs-6 text-dark mb-0 w-100" key={`list-${index}`}>
                  {str}
                </h4>
              </>
            );
          })}
        </Col>
      );
    }
    return null;
  };
  const _renderValueIf = (payout: any) => {
    if (payout?.value) {
      return (
        <Col xs={6} className="text-end">
          <span className="fs-6 fw-bolder text-dark">{payout?.value}</span>
        </Col>
      );
    }
  };
  const getListHeaders = () => {
    let _temp: any = [];
    if (Array.isArray(headers) && headers?.length > 0) {
      _temp = headers?.map((item, index) => {
        return <h6>{item}</h6>;
      });
    }
    return _temp;
  };

  const _renderCol1 = (data: any) => {
    return (
      <Col xs={6}>
        <S.ColContainer>
          {/* {_renderPercent(data)} */}
          {_renderTitleIf(data)}
        </S.ColContainer>
      </Col>
    );
  };

  const _renderCardBody = () => {
    if (listItems) {
      return (
        <Card.Body className="py-0">
          <ListGroup className="list-group-flush">
            {Array.isArray(headers) && headers?.length > 0 ? (
              <ListGroup.Item
                key={`option-item-header`}
                className="bg-transparent border-bottom py-3 px-0"
              >
                <S.ListHeader>{getListHeaders()}</S.ListHeader>
              </ListGroup.Item>
            ) : null}
            {listItems?.map((payout, index) => (
              <ListGroup.Item
                key={`option-item-${index}`}
                className="bg-transparent border-bottom py-3 px-0"
              >
                <Row className="align-items-center justify-content:space-between">
                  {_renderCol1(payout)}
                  {_renderValueIf(payout)}
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      );
    }
  };
  return (
    <Card border="0" className="shadow">
      {_renderTitle()}
      {_renderCardBody()}
    </Card>
  );
};

ListItemsComp.defaultProps = {
  headers: [],
  listItems: [],
};
